import { render, staticRenderFns } from "./endGame.vue?vue&type=template&id=7de79c11&scoped=true"
import script from "./endGame.vue?vue&type=script&lang=js"
export * from "./endGame.vue?vue&type=script&lang=js"
import style0 from "./endGame.vue?vue&type=style&index=0&id=7de79c11&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de79c11",
  null
  
)

export default component.exports